import * as React from "react";
const SvgFiRrFaceDrooling = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-drooling_svg__a)">
      <path
        fill="#062147"
        d="M24 12c0 2.488-.755 4.875-2.183 6.902a1 1 0 1 1-1.635-1.153 9.93 9.93 0 0 0 1.817-5.75c0-5.514-4.486-10-10-10S2 6.486 2 12c0 4.455 2.99 8.413 7.272 9.624.532.15.841.702.69 1.234a1 1 0 0 1-1.234.69C3.589 22.095 0 17.347 0 12 0 5.383 5.383 0 12 0s12 5.383 12 12M9.419 8.908a1 1 0 0 0-.838-1.816c-1.612.744-3.172 2.098-3.238 2.154a1.001 1.001 0 0 0 1.314 1.508c.014-.013 1.408-1.221 2.762-1.846m6-1.816a1.001 1.001 0 0 0-.838 1.816c1.347.622 2.748 1.834 2.762 1.846a.994.994 0 0 0 1.41-.098 1 1 0 0 0-.097-1.41c-.066-.057-1.625-1.41-3.237-2.154m2.035 7.378a1 1 0 0 0-1.042.081c-.02.015-2.027 1.449-4.411 1.449-2.314 0-4.287-1.705-4.335-1.747a1 1 0 0 0-1.331 1.493C6.438 15.838 8.894 18 12.001 18v3a1 1 0 1 0 2 0v-3.25a11 11 0 0 0 2-.683v5.934a1 1 0 1 0 2 0V15.36c0-.376-.213-.719-.547-.89"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-drooling_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceDrooling;
